/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from 'react';
import { Tooltip, DialogUtility } from '@syncfusion/ej2-popups';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Toolbar,
  Edit,
  Sort,
  Filter,
  ForeignKey,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { Link, useNavigate } from 'react-router-dom';

import { Query } from '@syncfusion/ej2-data';
import { useStateContext } from '../contexts/ContextProvider';
import orgpng from '../data/organization.png';
import { risksGrid } from '../data/dummy';
import { Header } from '../components';
import scribeHow from '../data/scribehow.png';

const Risks = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=risks');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);

  const { REACT_APP_API_ENDPOINT } = process.env;
  const toolbarOptions = ['Delete', 'Add', 'Edit', 'Search', 'ExcelExport'];
  const { activeMenu, zRenderMode, isMobile } = useStateContext();
  const selectionSettings = { mode: 'Row', type: 'Single' };
  const valuerules = { required: true };
  let crudUpdate = false;
  let crudCreate = false;
  let crudDelete = false;

  let grid;
  const orgData = [];
  let myScreenSize = 'auto';
  const {
    screenSize,
    setScreenSize,
  } = useStateContext();
  const tooltip = (args) => {
    const result = orgData.find(({ id }) => id === args.data.organizationid);
    let mycontent = '';
    switch (args.column.field) {
      case 'temperature':
        mycontent = 'Represents the graduation scale for the Temperature, ex. a temperature change of 2 degress multiplied time a RISK factor of 20 will result in an increase of 20 points';
        break;
      case 'oxygen':
        mycontent = 'Represents the graduation scale for the Oxygen, ex. an Oxygen change of 5% multiplied time a RISK factor of 10 will result in an increase of 10 points';
        break;
      case 'hydration':
        mycontent = 'Represents the graduation scale for the Hydration, ex. an Oxygen change of 10% multiplied time a RISK factor of 20 will result in an increase of 20 points';
        break;
      case 'heartrate':
        mycontent = 'Represents the graduation scale for the Heartrate, ex. a heartrate change of 10 BPM multiplied time a RISK factor of 20 will result in an increase of 20 points';
        break;
      case 'hrv':
        mycontent = 'Represents the graduation scale for the Heartrate Variability, ex. a HRV change of 10 milliseconds multiplied time a RISK factor of 20 will result in an increase of 20 points';
        break;
      case 'activity':
        mycontent = 'Not currently implemented';
        break;
      case 'age':
        mycontent = 'Represents the use of the Age graduation scale, used with Heartrate and Temperature, age group ranges are: 0-20, 21-30, 31-35, 36-40, 41-45, 45-50, 51-55, 56-60, 61-65, 66-70. ex. 0 means do not use age, 1 means use age when calculating RISK.';
        break;
      case 'male':
        mycontent = 'Represents the use of the Gender to factor to adjust RISK factor ex. 0 means do not use Gender, 1.1 means use a multiple of 1.1 when calculating RISK.';
        break;
      case 'female':
        mycontent = 'Represents the use of the Gender to factor to adjust RISK factor ex. 0 means do not use Gender, 1.2 means use a multiple of 1.1 when calculating RISK.';
        break;
      case 'risk':
        mycontent = 'Represents the incremental RISK factor from; HYPO (below normal: -1), BASELINE (0-25), MODERATE (25-50), ELEVATED (50-80), and SEVERE (80-100)';
        break;
      case 'organizationid':
        mycontent = `Represents which organization these factors apply: ${result.value}`;
        break;
      default:
        mycontent = '';
        break;
    }
    const tt = new Tooltip({
      content: mycontent,
    });
    tt.appendTo(args.cell);
  };

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  if (activeMenu === false) {
    myScreenSize = 'auto';
  } else {
    const s = (screenSize - 450).toString();
    myScreenSize = `${s}px`;
  }
  const gridOrgHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={orgpng}
        alt="organization"
      />
      <pre>Organization</pre>
    </div>
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/risks?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, []);

  const actionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      const result = orgData.find(({ id }) => id === args.rowData.organizationid);

      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.width = '50vw';
        dialog.header = `Risk Factors: ${result.value}`;
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });

        fetch(`${REACT_APP_API_ENDPOINT}/risks`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (!responseJson || !responseJson._id || responseJson._id.length === 0) {
              DialogUtility.alert('Risk add failed');
              args.cancel = true;
              return;
            }
            if (responseJson && responseJson._id) {
              data.risks[0]._id = responseJson._id;
            }
          })
          .catch(() => {
            DialogUtility.alert('An error has occured during Insert!');
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      // Here you can send the updated data to your server using AJAX call
      orgData.forEach((element) => {
        if (element.id === args.data.organizationid) {
          args.data.organizationid = element.id;
          args.data.organization = element.value;
        }
      });
      fetch(`${REACT_APP_API_ENDPOINT}/risks`, {
        method: 'UPDATE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(args.data),
      })
        .then((response) => response.json())
        .then(() => {
          // The added/edited data will be saved in the Grid
          // The default edit operation is cancelled
          grid.endEdit();
        })
        .catch(() => {
          DialogUtility.alert('An error has occured during Update!');
        });
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/risks`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
          })
          .catch(() => {
            DialogUtility.alert('An error has occured during Delete!');
          });
      }
    }
  };
  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `Risks_${new Date().toISOString()}.xlsx`,
      };
      grid.excelExport(properties);
    }
  };

  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.role && data.role.alerts) {
    if (data.role.alerts.permissions.includes('Create')) {
      crudCreate = true;
    }
    if (data.role.alerts.permissions.includes('Update')) {
      crudUpdate = true;
    }
    if (data.role.alerts.permissions.includes('Delete')) {
      crudDelete = true;
    }
    if (!data.role.alerts.permissions.includes('Read')) {
      return <p>Not authorized...</p>;
    }
  }
  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Dialog',
  };
  const editingMobile = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Normal',
  };
  if (data.organization) {
    data.organization.forEach((org) => {
      orgData.push({ id: org._id, value: org.title });
    });
  }
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/Risk_threshold_and_configuration_settings__LLNJadhCThKgUojCxYUjjQ"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="SafeGuards" title="Risk Threshold Factors" />
      </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={data.risks}
              width={myScreenSize}
              allowPaging
              allowSorting
              allowExcelExport
              pageSettings={{ pageSize: 20 }}
              editSettings={isMobile ? editingMobile : editing}
              enableStickyHeader
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              actionComplete={actionComplete}
              selectionSettings={selectionSettings}
              queryCellInfo={tooltip}
              allowTextWrap
              ref={(g) => { grid = g; }}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {risksGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="150"
                  textAlign="Left"
                  editType="dropdownedit"
                  headerTemplate={gridOrgHeader}
                  edit={organizations}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  validationRules={valuerules}
                  dataSource={organizations.params.dataSource}
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Toolbar, Edit, Sort, Filter, ForeignKey, ExcelExport]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Risks;
